/* ADM Sport — fiche produit, gains rapides sur le thème actuel (ADM-Theme-1.0).
   v0.1 — 29 septembre 2026. Va avec adm-fiche.css.
   v0.2 — 6 octobre 2026 : retours 14 jours (au lieu de 15, selon la page Retours) ;
          tirage du test A/B gardé dans localStorage (au lieu de sessionStorage) ;
          cueillette : carte-cadeau « dès 100 $ », et pas de carte-cadeau mentionnée sur les pneus.
   v0.3 — 6 octobre 2026 : retrait de la catégorie dans le fil d'Ariane (le lien par type mène à une
          liste mélangée, et à une page 404 sur le site anglais). À reprendre avec des collections choisies.
          Le lien « Voir d'autres modèles en stock » est gardé, en français seulement.
   v0.4 — 6 octobre 2026 : un toucher sur une couleur de la phrase change bien la couleur
          (le script cliquait le bouton radio caché, que le thème n'écoute pas ; il clique maintenant la pastille).
   v0.5 — 6 octobre 2026 : les phrases nomment toujours la taille (« il reste seulement la taille 14 »,
          « La taille M est en rupture… ») : avec des tailles en chiffres, « il reste seulement 14 » se lisait
          comme une quantité.
   v0.6 — 7 octobre 2026 : produits à 3 options (Longueur, Visière…). La phrase tient compte de la 3e option :
          « En Noir, la taille 3TG est disponible en : Régulier » au lieu de « rupture dans toutes les couleurs » ;
          chaque bouton de la phrase vise une variante et règle toutes les options qui diffèrent.
   v0.7 — 8 octobre 2026 : combinaison d'options sans variante (ex. pneu Front + une dimension qui n'existe
          qu'en Rear). La disponibilité affichait encore les magasins de la variante précédente ; elle dit
          maintenant « Indisponible », et la phrase propose les options où la taille existe en stock.
   v0.8 — 8 octobre 2026 : stock de 10 et plus. Au-delà de 9, l'application de stock envoie un seuil « 10+ »
          (.iia-stock-threshold) au lieu du nombre (.iia-qty) ; le script l'ignorait et annonçait « expédié en
          3 à 12 jours », voire « Rupture », alors que le produit était en magasin. Le seuil est lu et masqué,
          le « - » devant aussi. Produit sans option : le thème ne donne pas la liste des variantes, on se fie
          au bouton d'achat (actif = vendable) plutôt que de conclure « Rupture ».
   v0.9 — 8 octobre 2026 : deux lignes, décidées avec l'équipe. En vert, « En magasin · … » si un magasin a du
          stock (l'entrepôt de liquidation est un magasin comme les autres : plus de « En stock à notre entrepôt »).
          En bleu, toujours, le délai : « Expédié en 24 à 48 h » s'il y a du stock en magasin, sinon « Expédié en
          2 à 8 jours » (fournisseur, ou vendable sans stock trouvé). Rupture et « Indisponible » : pas de ligne bleue.
   v0.10 — 8 octobre 2026 : lien « Voir d'autres modèles en stock » retiré (il mène à /collections/types?q=…, une liste
          trop générale, signalé par Michaël sur le casque Fox Rampage Pro Carbon Intrude). Réglage LIEN_AUTRES = true pour le remettre.
   v0.11 — 8 octobre 2026 (décision de Michaël) : retours 15 jours (au lieu de 14) ; stock en magasin « Expédié en 24 à 72 h »
          (au lieu de 24 à 48 h). Attention : la page Retours dit encore 14 jours.
   v0.12 — 8 octobre 2026 : « Appeler un conseiller » à l'infinitif (au lieu de « Appelle »), demande de Michaël.
   v0.13 — 8 octobre 2026 : une option nommée « Dimension… » (pneus : « Dimension de pneu ») compte comme la taille.
          Sur une combinaison inexistante (K299 Bearclaw Avant-Arrière + 22X8-10), la phrase disait seulement
          « Indisponible. » ; elle dit maintenant « Indisponible. La taille 22X8-10 est disponible en : Avant » (cliquable).
   v0.14 — 19 octobre 2026 (demande de Michaël) : sans stock en magasin mais vendable (fournisseur, ou vendable sans
          stock trouvé), la ligne verte dit « Disponible sur commande » / « Available to order » ; la ligne bleue
          « Expédié en 2 à 8 jours » reste dessous. Toujours deux lignes, vert puis bleu, quand le produit est vendable.
   v0.15 — 22 octobre 2026 (demande de mesure relayée par Michaël) : à chaque ajout au panier, un événement
          dataLayer { event: 'adm_ajout', adm_ajout_source: 'barre' | 'bouton' } : 'barre' = la barre d'achat mobile,
          'bouton' = le bouton principal de la fiche. But : vérifier si la barre fait ajouter la taille présélectionnée
          (plus de retraits du panier sur téléphone). Un toucher sur la barre ne compte qu'une fois (elle clique le
          bouton principal à sa place). Rien n'est envoyé si le bouton est désactivé. Ajout par la touche Entrée : non compté.
          Seulement sur la nouvelle fiche. Rien ne change à l'écran.
   Ce que fait ce fichier, et rien d'autre (les tailles barrées, la place du bouton, le bandeau unique
   et le titre de la description sont dans adm-fiche.css) :
     1. dit dans quelles couleurs la taille voulue existe quand elle est en rupture ;
     2. résume la disponibilité en une ligne au-dessus du bouton (l'application de stock reste, sous le bouton) ;
     3. ajoute ce qui rassure sous le bouton (livraison, cueillette, retours, meilleur prix, conseiller) ;
     4. garde un bouton d'achat à l'écran sur mobile.
   (La catégorie dans le fil d'Ariane a été retirée en v0.3.)
   Il ne touche ni au panier, ni aux prix. Il lit la fiche, il n'écrit rien chez Shopify.

   Réglages (facultatifs, à poser AVANT ce fichier) :
     window.ADM_FICHE = { actif: true, part: 100 };
       actif : false  -> rien ne change, sauf avec « ?adm-fiche=1 » dans l'adresse (pour relire avant d'allumer)
       part  : 50     -> la moitié des visiteurs voit la nouvelle fiche ; l'autre moitié voit l'ancienne
   Mesure : un événement « adm_fiche » part dans dataLayer avec la version vue (« nouvelle » ou « actuelle »).
   Depuis la v0.15, sur la nouvelle fiche, un événement « adm_ajout » part à chaque ajout, avec sa source (« barre » ou « bouton »). */
(function () {
  'use strict';
  if (window.__admFiche) { return; }
  window.__admFiche = '0.15';

  var d = document, root = d.documentElement;
  var form = d.querySelector('form.shopify-product-form');
  var btn = d.querySelector('.product-form__submit');
  if (!form || !btn) { return; }

  /* ---------- allumé ou non ---------- */
  var cfg = window.ADM_FICHE || {};
  var force = /[?&]adm-fiche=1/.test(location.search), off = /[?&]adm-fiche=0/.test(location.search);
  var version = 'nouvelle';
  if (off) { version = 'actuelle'; }
  else if (!force) {
    if (cfg.actif === false) { version = 'actuelle'; }
    else if (typeof cfg.part === 'number' && cfg.part < 100) {
      var tirage = null;
      /* localStorage : le même visiteur garde la même version d'une visite à l'autre pendant tout le test */
      try { tirage = localStorage.getItem('adm-f-tirage'); } catch (e) {}
      if (tirage === null) {
        tirage = String(Math.floor(Math.random() * 100));
        try { localStorage.setItem('adm-f-tirage', tirage); } catch (e) {}
      }
      if (Number(tirage) >= cfg.part) { version = 'actuelle'; }
    }
  }
  try { (window.dataLayer = window.dataLayer || []).push({ event: 'adm_fiche', adm_fiche_version: version }); } catch (e) {}
  if (version !== 'nouvelle') { return; }
  root.className += ' adm-f';

  /* ---------- les mots ---------- */
  var EN = (root.lang || '').toLowerCase().indexOf('en') === 0;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = EN ? {
    outIn: 'Size {t} is out of stock in {c}.', alsoIn: 'In stock in:', outAll: 'Size {t} is out of stock in every colour.',
    outOne: 'Size {t} is out of stock.', outVar: '{t} is out of stock.',
    otherOptC: 'In {c}, size {t} is available in:', otherOpt: 'Size {t} is available in:',
    noComboT: 'Unavailable. Size {t} is available in:', noCombo: 'Unavailable.',
    noDispo: 'Unavailable',
    few1: 'In {c}, only size {l} left.', fewN: 'In {c}, only sizes {l} left.', more: 'More sizes in:',
    others: 'See other {k} in stock', store: 'In store', order: 'Available to order',
    soon: 'Ships in 24–72 hours', later: 'Ships in 2–8 days', out: 'Out of stock', byStore: 'Stock by store',
    add: 'Add to cart', change: 'Change', size: 'Size',
    ship: '<b>Free shipping</b> from $49 · <a href="{u}">Details</a>',
    pick: '<b>Free pickup</b> at our 4 stores, plus a $10 gift card from $100 · <a href="{u}">Details</a>',
    pickPneu: '<b>Free pickup</b> at our 4 stores · <a href="{u}">Details</a>',
    ret: '<a href="{u}">Returns and refunds</a>: 15 days', best: '<a href="{u}">Best price guaranteed</a>',
    call: 'Call an expert · <a href="tel:+18004634340">1 800 463-4340</a>',
    and: ' and '
  } : {
    outIn: 'La taille {t} est en rupture en {c}.', alsoIn: 'Disponible en :', outAll: 'La taille {t} est en rupture dans toutes les couleurs.',
    outOne: 'La taille {t} est en rupture.', outVar: '{t} est en rupture.',
    otherOptC: 'En {c}, la taille {t} est disponible en :', otherOpt: 'La taille {t} est disponible en :',
    noComboT: 'Indisponible. La taille {t} est disponible en :', noCombo: 'Indisponible.',
    noDispo: 'Indisponible',
    few1: 'En {c}, il reste seulement la taille {l}.', fewN: 'En {c}, il reste seulement les tailles {l}.', more: 'Plus de tailles en :',
    others: 'Voir d’autres modèles en stock ({k})', store: 'En magasin', order: 'Disponible sur commande',
    soon: 'Expédié en 24 à 72 h', later: 'Expédié en 2 à 8 jours', out: 'Rupture de stock', byStore: 'Stock par magasin',
    add: 'Ajouter au panier', change: 'Changer', size: 'Taille',
    ship: '<b>Livraison gratuite</b> dès 49 $ · <a href="{u}">Détails</a>',
    pick: '<b>Cueillette gratuite</b> dans nos 4 magasins, et une carte-cadeau de 10 $ dès 100 $ · <a href="{u}">Détails</a>',
    pickPneu: '<b>Cueillette gratuite</b> dans nos 4 magasins · <a href="{u}">Détails</a>',
    ret: '<a href="{u}">Retours et remboursements</a> : 15 jours', best: '<a href="{u}">Meilleur prix garanti</a>',
    call: 'Appeler un conseiller · <a href="tel:+18004634340">1 800 463-4340</a>',
    and: ' et '
  };
  function fill(s, o) { return s.replace(/\{(\w)\}/g, function (m, k) { return o[k] === undefined ? m : o[k]; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function el(tag, cls, html) { var n = d.createElement(tag); if (cls) { n.className = cls; } if (html) { n.innerHTML = html; } return n; }

  /* ---------- le produit ---------- */
  var variants = [], options = [];
  try { variants = JSON.parse(d.querySelector('script[id^="ProductJson-"]').textContent) || []; } catch (e) {}
  try { options = JSON.parse(d.querySelector('script[id^="ProductOptions-"]').textContent) || []; } catch (e) {}
  var iTaille = -1, iCouleur = -1;
  for (var i = 0; i < options.length; i++) {
    if (iTaille < 0 && /taille|size|grandeur|pointure|dimension/i.test(options[i].name)) { iTaille = i; }
    if (iCouleur < 0 && /couleur|color|colour/i.test(options[i].name)) { iCouleur = i; }
  }
  var type = btn.getAttribute('data-product-type') || '';

  function choix() {
    var c = [], ins = form.querySelectorAll('input[type="radio"][data-option-position]:checked');
    for (var k = 0; k < ins.length; k++) { c[Number(ins[k].getAttribute('data-option-position')) - 1] = ins[k].value; }
    return c;
  }
  function trouve(c) {
    for (var k = 0; k < variants.length; k++) {
      var v = variants[k], o = v.options || [], ok = true;
      for (var j = 0; j < o.length; j++) { if (c[j] !== undefined && o[j] !== c[j]) { ok = false; break; } }
      if (ok) { return v; }
    }
    return null;
  }

  /* ---------- 1. la taille existe ailleurs ---------- */
  var noteHtml = '';
  var note = el('p', 'adm-f-note'); note.hidden = true; note.setAttribute('aria-live', 'polite');
  var fieldsets = form.querySelectorAll('fieldset.product-form__option');
  var ancre = fieldsets.length ? fieldsets[fieldsets.length - 1] : null;
  if (ancre && ancre.parentNode) { ancre.parentNode.insertBefore(note, ancre.nextSibling); }

  /* les options qui ne sont ni la taille ni la couleur (Longueur, Visière…) */
  var autres = [];
  for (var a = 0; a < options.length; a++) { if (a !== iTaille && a !== iCouleur) { autres.push(a); } }
  function memesAutres(w, c) {
    for (var j = 0; j < autres.length; j++) { var x = autres[j]; if (c[x] !== undefined && w.options[x] !== c[x]) { return false; } }
    return true;
  }
  function libAutres(w) {
    var l = [];
    for (var j = 0; j < autres.length; j++) { l.push(w.options[autres[j]]); }
    return l.join(' / ');
  }
  /* chaque bouton vise une variante précise : un toucher règle toutes les options qui diffèrent */
  function liens(cibles) {
    var h = '<span class="adm-f-colors">';
    for (var k = 0; k < cibles.length; k++) { h += '<button type="button" data-adm-v="' + cibles[k].id + '">' + esc(cibles[k].lib) + '</button>'; }
    return h + '</span>';
  }
  var LIEN_AUTRES = false;   /* v0.10 : lien retiré (mène à une liste trop générale) ; true pour le remettre */
  function lienType() {
    /* français seulement : en anglais le type est traduit et /collections/types?q=… mène à une page 404 */
    if (!LIEN_AUTRES || !type || EN) { return ''; }
    return ' <a href="' + base + 'collections/types?q=' + encodeURIComponent(type) + '">' + fill(T.others, { k: esc(type) }) + '</a>';
  }
  function majNote() {
    if (!note.parentNode || !variants.length) { return; }
    var c = choix(), v = trouve(c), h = '';
    if (!v) {
      /* combinaison qui n'existe pas (ex. Front + 23x10.00-10 alors que cette dimension n'existe qu'en Rear) :
         on propose les combinaisons en stock qui gardent la taille choisie */
      var tC = iTaille >= 0 ? c[iTaille] : undefined, cibles = [], vusLib = {};
      if (tC !== undefined) {
        for (var z = 0; z < variants.length; z++) {
          var y = variants[z];
          if (!y.available || y.options[iTaille] !== tC) { continue; }
          var diff = [];
          for (var q = 0; q < y.options.length; q++) { if (q !== iTaille && y.options[q] !== c[q]) { diff.push(y.options[q]); } }
          var lib = diff.join(' / ');
          if (lib && !vusLib[lib]) { vusLib[lib] = 1; cibles.push({ id: y.id, lib: lib }); }
        }
      }
      h = cibles.length ? fill(T.noComboT, { t: '<b>' + esc(tC) + '</b>' }) + liens(cibles) : T.noCombo;
    }
    else if (iTaille >= 0 && c[iTaille] !== undefined) {
      var taille = c[iTaille], couleur = iCouleur >= 0 ? c[iCouleur] : null;
      var ici = [], parCouleur = {}, versCouleur = {}, autreOpt = [], ailleurs = [], vus = {};
      for (var k = 0; k < variants.length; k++) {
        var w = variants[k]; if (!w.available) { continue; }
        var wc = iCouleur >= 0 ? w.options[iCouleur] : '', meme = memesAutres(w, c), memeTaille = w.options[iTaille] === taille;
        if (meme) {
          parCouleur[wc] = (parCouleur[wc] || 0) + 1;
          if (!versCouleur[wc] || memeTaille) { versCouleur[wc] = w.id; }
          if (wc === couleur || iCouleur < 0) { ici.push(w.options[iTaille]); }
        }
        if (!memeTaille) { continue; }
        if ((wc === couleur || iCouleur < 0) && !meme) { autreOpt.push({ id: w.id, lib: libAutres(w) }); }
        else if (wc !== couleur && iCouleur >= 0) {
          /* une autre couleur où la taille existe : on préfère la variante qui garde la même longueur/visière */
          if (vus[wc] === undefined) { vus[wc] = ailleurs.length; ailleurs.push({ id: w.id, lib: wc }); }
          else if (meme) { ailleurs[vus[wc]].id = w.id; }
        }
      }
      var tb = '<b>' + esc(taille) + '</b>';
      if (v && !v.available) {
        if (autreOpt.length) {
          /* même couleur, même taille, mais une autre longueur / visière */
          h = (iCouleur >= 0 ? fill(T.otherOptC, { c: esc(couleur), t: tb }) : fill(T.otherOpt, { t: tb })) + liens(autreOpt);
        }
        else if (iCouleur >= 0 && ailleurs.length) { h = fill(T.outIn, { t: tb, c: esc(couleur) }) + ' ' + T.alsoIn + liens(ailleurs); }
        else { h = fill(iCouleur >= 0 ? T.outAll : T.outOne, { t: tb }) + lienType(); }
      } else if (v && iCouleur >= 0 && ici.length <= 2 && options[iTaille].values.length >= 4) {
        var mieux = [];
        for (var n in parCouleur) { if (parCouleur.hasOwnProperty(n) && n !== couleur && parCouleur[n] > ici.length) { mieux.push({ id: versCouleur[n], lib: n }); } }
        if (mieux.length) { h = fill(ici.length > 1 ? T.fewN : T.few1, { c: esc(couleur), l: '<b>' + esc(ici.join(T.and)) + '</b>' }) + ' ' + T.more + liens(mieux); }
      }
    } else if (v && !v.available) {
      /* pas d'option de taille : on nomme la variante telle quelle (ex. « Rouge / 1L est en rupture. ») */
      h = fill(T.outVar, { t: '<b>' + esc(v.public_title || v.title || '') + '</b>' }) + lienType();
    }
    if (h !== noteHtml) { noteHtml = h; note.innerHTML = h; note.hidden = !h; }
  }
  note.addEventListener('click', function (e) {
    var id = e.target && e.target.getAttribute && e.target.getAttribute('data-adm-v');
    if (!id) { return; }
    var cible = null;
    for (var k = 0; k < variants.length; k++) { if (String(variants[k].id) === id) { cible = variants[k]; break; } }
    if (!cible) { return; }
    /* on règle chaque option qui diffère, une à une ; le thème écoute le clic sur l'étiquette (label)
       de la pastille, pas sur le bouton radio caché */
    var file = [], c = choix();
    for (var j = 0; j < cible.options.length; j++) { if (c[j] !== cible.options[j]) { file.push(j); } }
    (function suivant() {
      if (!file.length) { return; }
      var pos = file.shift(), val = cible.options[pos];
      var ins = form.querySelectorAll('input[type="radio"][data-option-position="' + (pos + 1) + '"]');
      for (var m = 0; m < ins.length; m++) {
        if (ins[m].value === val) { var lab = ins[m].closest ? ins[m].closest('label') : null; (lab || ins[m]).click(); break; }
      }
      setTimeout(suivant, 150);
    })();
  });

  /* ---------- 2. la disponibilité en une ligne ---------- */
  /* deux lignes : « où » en vert (magasins, l'entrepôt de liquidation compris), puis « quand » en bleu (délai d'expédition) */
  var dispo = el('p', 'adm-f-dispo'); dispo.hidden = true;
  var delai = el('p', 'adm-f-dispo later'); delai.hidden = true;
  var qte = form.querySelector('quantity-input');
  var enveloppe = form.querySelector('.product-form__add-to-cart-wrapper');
  if (qte && qte.parentNode === form) { form.insertBefore(dispo, qte); form.insertBefore(delai, qte); }
  else if (enveloppe) { enveloppe.parentNode.insertBefore(dispo, enveloppe); enveloppe.parentNode.insertBefore(delai, enveloppe); }
  function ligne(p, cls, txt) {
    if (!txt) { if (!p.hidden) { p.hidden = true; } return; }
    var c = 'adm-f-dispo ' + cls;
    if (p.className !== c) { p.className = c; }
    if (p.textContent !== txt) { p.textContent = txt; }
    if (p.hidden) { p.hidden = false; }
  }

  /* Shopify vend-il cette variante ? Sur un produit sans option, le thème ne met pas la liste des
     variantes dans la page (ProductJson n'existe que s'il y a plus d'une variante) : on se fie alors
     au bouton d'achat du thème, actif = vendable. */
  function vendable(v) {
    if (v) { return !!v.available; }
    if (!variants.length) { return !btn.disabled; }
    return false;
  }
  var enCours = false;
  function majDispo() {
    var app = d.getElementById('inventory-info-app');
    if (!app || enCours) { return; }
    enCours = true;
    try {
      var items = app.querySelectorAll('.iia-list-item'), mags = [], plusTard = 0;
      for (var k = 0; k < items.length; k++) {
        /* l'application donne le nombre exact jusqu'à 9 (.iia-qty), puis un seuil « 10+ » (.iia-stock-threshold) */
        var lieu = items[k].querySelector('.iia-location'), q = items[k].querySelector('.iia-qty') || items[k].querySelector('.iia-stock-threshold');
        if (!lieu || !q) { continue; }
        var nom = (lieu.getAttribute('data-adm-nom') || lieu.textContent || '').replace(/\s+/g, ' ').trim();
        lieu.setAttribute('data-adm-nom', nom);
        var nb = parseInt(q.textContent, 10) || 0;
        var classe = items[k].className.replace(/ ?adm-f-zero/g, '') + (nb > 0 ? '' : ' adm-f-zero');
        if (classe !== items[k].className) { items[k].className = classe; }
        /* tout lieu qui n'est pas le fournisseur est un magasin (l'entrepôt de liquidation aussi) */
        if (/fournisseur|supplier/i.test(nom)) { plusTard += nb; if (nb > 0 && lieu.textContent !== T.later) { lieu.textContent = T.later; } }
        else if (nb > 0) { mags.push(nom); }
        /* ni quantité ni tiret : le client veut savoir où, pas combien */
        var titre = items[k].querySelector('.iia-title-text');
        if (titre) {
          for (var j = titre.childNodes.length - 1; j >= 0; j--) {
            if (titre.childNodes[j].nodeType === 3 && titre.childNodes[j].nodeValue !== '') { titre.childNodes[j].nodeValue = ''; }
          }
        }
        if (q.className.indexOf('adm-f-hide') < 0) { q.className += ' adm-f-hide'; }
      }
      var entete = app.querySelector('.iia-header');
      if (entete && entete.textContent !== T.byStore) { entete.textContent = T.byStore; }
      var pied = app.querySelector('.iia-footer');
      if (pied && pied.className.indexOf('adm-f-hide') < 0) { pied.className += ' adm-f-hide'; }
      var existe = trouve(choix());
      if (!existe && variants.length) {
        /* combinaison sans variante : l'application de stock montre encore la variante précédente, on ne la croit pas */
        ligne(dispo, 'out', T.noDispo); ligne(delai, 'later', '');
      }
      else if (!items.length) {
        /* l'application n'a encore rien affiché : on ne dit que la rupture, pour ne pas annoncer un délai qui changerait ensuite */
        ligne(dispo, 'out', vendable(existe) ? '' : T.out); ligne(delai, 'later', '');
      }
      else if (mags.length) { ligne(dispo, 'in', T.store + ' · ' + mags.join(', ')); ligne(delai, 'later', T.soon); }
      else if (plusTard > 0 || vendable(existe)) { ligne(dispo, 'in', T.order); ligne(delai, 'later', T.later); }
      else { ligne(dispo, 'out', T.out); ligne(delai, 'later', ''); }
      if (items.length && (existe || !variants.length)) {
        var vue = (mags.length || plusTard > 0) ? '' : 'none';
        if (app.style.display !== vue) { app.style.display = vue; }
      }
    } catch (e) {}
    enCours = false;
  }
  function rangeApp() {
    /* l'application de stock passe SOUS la ligne du bouton, repliée, sur mobile comme sur desktop */
    var app = d.getElementById('inventory-info-app');
    if (!app || !enveloppe || app.getAttribute('data-adm-range')) { return; }
    app.setAttribute('data-adm-range', '1');
    if (enveloppe.parentNode) { enveloppe.parentNode.insertBefore(app, enveloppe.nextSibling); }
    var detail = app.querySelector('.iia-details-container'), tete = app.querySelector('.iia-header-container');
    if (detail && tete && detail.className.indexOf('iia-collapsed') < 0) { try { tete.click(); } catch (e) {} }
  }

  /* ---------- 3. ce qui rassure ---------- */
  var ICO = {
    camion: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    lieu: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>',
    retour: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5 4 9l4 4"/><path d="M4 9h10a6 6 0 0 1 0 12H9"/></svg>',
    prix: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.3"/></svg>',
    bulle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v11H9l-5 4z"/></svg>'
  };
  /* les pages du site qui disent la règle : une phrase affichée doit se retrouver dans un document */
  var PAGES = {
    ship: 'pages/livraison-de-votre-commande',
    pick: 'pages/service-de-cueillette-en-magasin-in-store-pickup',
    ret: 'pages/retours-et-remboursements-return-and-or-refund-of-your-purchase',
    best: 'pages/politique-du-meilleur-prix-best-price-policy'
  };
  function rassure() {
    if (!enveloppe || form.querySelector('.adm-f-rassure')) { return; }
    var lourd = /^(pneu|tire|chenille|track|coffre)/i.test(type);   /* la fiche annonce déjà ses frais de livraison */
    var h = '';
    var marque = btn.getAttribute('data-product-vendor') || '';
    if (!lourd) { h += '<li>' + ICO.camion + '<span>' + fill(T.ship, { u: base + PAGES.ship }) + '</span></li>'; }
    /* la carte-cadeau de 10 $ : dès 100 $ avant taxes, et pas sur les pneus (page Cueillette) */
    var pneu = /^(pneu|tire)/i.test(type);
    h += '<li>' + ICO.lieu + '<span>' + fill(pneu ? T.pickPneu : T.pick, { u: base + PAGES.pick }) + '</span></li>';
    h += '<li>' + ICO.retour + '<span>' + fill(T.ret, { u: base + PAGES.ret }) + '</span></li>';
    /* Sena et Scala sont exclues de la politique du meilleur prix */
    if (!/^(sena|scala)/i.test(marque)) { h += '<li>' + ICO.prix + '<span>' + fill(T.best, { u: base + PAGES.best }) + '</span></li>'; }
    h += '<li>' + ICO.bulle + '<span>' + T.call + '</span></li>';
    var ul = el('ul', 'adm-f-rassure', h);
    enveloppe.parentNode.insertBefore(ul, enveloppe.nextSibling);
  }

  /* ---------- mesure des ajouts (v0.15) ---------- */
  /* relais = true pendant que la barre clique le bouton principal à sa place : ce clic-là est déjà compté « barre » */
  var relais = false;
  function mesureAjout(source) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'adm_ajout', adm_ajout_source: source }); } catch (e) {}
  }
  btn.addEventListener('click', function () {
    if (relais || btn.disabled) { return; }
    mesureAjout('bouton');
  }, true);

  /* ---------- 4. la barre d'achat, mobile ---------- */
  var barre = null, bPrix, bVar, bBtn, barHtml = '';
  function montreBarre(oui) {
    if (!barre) { return; }
    barre.className = 'adm-f-bar' + (oui ? ' on' : '');
    root.className = root.className.replace(/ ?adm-f-bar-on/g, '') + (oui ? ' adm-f-bar-on' : '');
  }
  function creeBarre() {
    if (barre || !('IntersectionObserver' in window)) { return; }
    barre = el('div', 'adm-f-bar');
    barre.setAttribute('role', 'region'); barre.setAttribute('aria-label', T.add);
    barre.innerHTML = '<div class="adm-f-bar-t"><span class="adm-f-bar-p"></span><span class="adm-f-bar-v"></span></div>' +
      '<button type="button" class="adm-f-bar-b"></button>';
    d.body.appendChild(barre);
    bPrix = barre.querySelector('.adm-f-bar-p'); bVar = barre.querySelector('.adm-f-bar-v'); bBtn = barre.querySelector('.adm-f-bar-b');
    bBtn.addEventListener('click', function () {
      if (btn.disabled) { return; }
      mesureAjout('barre');
      relais = true;
      try { btn.click(); } finally { relais = false; }
    });
    barre.addEventListener('click', function (e) {
      if (e.target && e.target.getAttribute && e.target.getAttribute('data-adm-change') !== null) {
        var cible = form.querySelector('.product-form__options') || form;
        var y = cible.getBoundingClientRect().top + (window.pageYOffset || root.scrollTop) - 110;
        window.scrollTo(0, Math.max(0, y));
      }
    });
    new IntersectionObserver(function (es) { montreBarre(!es[0].isIntersecting); }, { threshold: 0 }).observe(btn);
  }
  function majBarre() {
    if (!barre) { return; }
    var prix = d.querySelector('.product-main__price .price__sale .price-item--sale, .product-main__price .price-item--sale, .product-main__price .price-item--regular');
    var c = choix(), bouts = [];
    if (iTaille >= 0 && c[iTaille] !== undefined) { bouts.push(T.size + ' ' + c[iTaille]); }
    for (var k = 0; k < c.length; k++) { if (c[k] !== undefined && k !== iTaille) { bouts.push(c[k]); } }
    var p = prix ? prix.textContent.replace(/\s+/g, ' ').trim() : '';
    if (bPrix.textContent !== p) { bPrix.textContent = p; }
    var hv = bouts.length ? '<span class="adm-f-bar-vt">' + esc(bouts.join(' · ')) + '</span><button type="button" data-adm-change>' + T.change + '</button>' : '';
    if (hv !== barHtml) { barHtml = hv; bVar.innerHTML = hv; }
    var libelle = btn.querySelector('.button-text');
    var lb = (libelle ? libelle.textContent : btn.textContent).replace(/\s+/g, ' ').trim() || T.add;
    if (bBtn.textContent !== lb) { bBtn.textContent = lb; }
    if (bBtn.disabled !== !!btn.disabled) { bBtn.disabled = !!btn.disabled; }
  }


  /* ---------- tout remettre à jour quand le choix change ---------- */
  var minuterie = null;
  function maj() {
    clearTimeout(minuterie);
    minuterie = setTimeout(function () { majNote(); rangeApp(); majDispo(); majBarre(); }, 80);
  }
  form.addEventListener('change', maj, true);
  if ('MutationObserver' in window) {
    /* le thème et l'application de stock réécrivent la zone d'achat : on suit le formulaire entier.
       Toutes nos écritures sont faites seulement si la valeur change, donc pas de boucle. */
    new MutationObserver(maj).observe(form, { childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['disabled', 'data-product-variant'] });
    var prixBloc = d.querySelector('.product-main__price');
    if (prixBloc) { new MutationObserver(maj).observe(prixBloc, { childList: true, subtree: true, characterData: true }); }
  }
  rassure(); creeBarre(); maj();
})();